// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606260744/js/" + chunkId + "." + {"44":"a8d5ee82","225":"09070d80","481":"13e14c29","486":"d7f6d344","770":"ecbfa1c2"}[chunkId] + ".0.01717786331851856.chunk.js";
};